function Step3Svg() {
    return (
        <svg width='129' height='102' viewBox='0 0 129 102' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <ellipse cx='80.5968' cy='62' rx='39.403' ry='40' fill='#FFEDF3' />
            <circle cx='80.5967' cy='61.4028' r='30.4478' fill='#FFD1E1' />
            <path
                d='M76.3958 48.9585V46.8335C76.3958 46.2527 75.9141 45.771 75.3333 45.771C74.7524 45.771 74.2708 46.2527 74.2708 46.8335V49.0435C74.6249 49.001 74.9508 48.9585 75.3333 48.9585H76.3958Z'
                fill='#ED236B'
            />
            <path
                d='M87.7292 49.0435V46.8335C87.7292 46.2527 87.2476 45.771 86.6667 45.771C86.0859 45.771 85.6042 46.2527 85.6042 46.8335V48.9585H86.6667C87.0492 48.9585 87.3751 49.001 87.7292 49.0435Z'
                fill='#ED236B'
            />
            <path
                d='M87.7292 49.0435V51.0835C87.7292 51.6643 87.2475 52.146 86.6667 52.146C86.0858 52.146 85.6042 51.6643 85.6042 51.0835V48.9585H76.3958V51.0835C76.3958 51.6643 75.9142 52.146 75.3333 52.146C74.7525 52.146 74.2708 51.6643 74.2708 51.0835V49.0435C70.0917 49.426 68.25 52.1177 68.25 56.0418V68.0835C68.25 72.3335 70.375 75.1668 75.3333 75.1668H86.6667C91.625 75.1668 93.75 72.3335 93.75 68.0835V56.0418C93.75 52.1177 91.9083 49.426 87.7292 49.0435ZM81 67.7293H75.3333C74.7525 67.7293 74.2708 67.2477 74.2708 66.6668C74.2708 66.086 74.7525 65.6043 75.3333 65.6043H81C81.5808 65.6043 82.0625 66.086 82.0625 66.6668C82.0625 67.2477 81.5808 67.7293 81 67.7293ZM86.6667 60.646H75.3333C74.7525 60.646 74.2708 60.1643 74.2708 59.5835C74.2708 59.0027 74.7525 58.521 75.3333 58.521H86.6667C87.2475 58.521 87.7292 59.0027 87.7292 59.5835C87.7292 60.1643 87.2475 60.646 86.6667 60.646Z'
                fill='#ED236B'
            />
            <circle cx='6' cy='6' r='6' transform='matrix(-1 0 0 1 12 15)' fill='#C6C3FB' />
            <circle cx='4' cy='4' r='4' transform='matrix(-1 0 0 1 64 0)' fill='#FED883' />
            <circle cx='2' cy='2' r='2' transform='matrix(-1 0 0 1 20 75)' fill='#651FFF' />
            <circle cx='3' cy='3' r='3' transform='matrix(-1 0 0 1 129 85)' fill='#FEB5BD' />
        </svg>
    );
}

export default Step3Svg;
